module.exports = __webpack_public_path__ + "static/media/file-download.98eb2bd0.svg";